import React from 'react'
import propTypes from 'prop-types'
import styled from '@emotion/styled';
import client from '../../src/graphql/client';
import {gql} from "@apollo/client";
import {get} from 'lodash';
import {theme} from '../../src/themes/default-theme';
import seoQuery from '../../src/graphql/queries/seo';
import contentBuilderQuery from '../../src/graphql/queries/content-builder';
import dlPush from '../../src/util/dlPush';

import refactorBreadcrumbsData from '../../src/data-restructure/navigation/breadcrumbs/breadcrumbs';
import refactorHb from '../../src/data-restructure/multimedia/hero-banner';
import refactorHBCData from '../../src/data-restructure/multimedia/hero-banner-carousel';

// components
import Banner from '../../src/components/multimedia/Banner';
import BannerSlider from '../../src/components/multimedia/BannerSlider';

const Container = styled.div`
  margin-bottom: 80px;
  ${theme.breakpoints.up('md')} {
    margin-bottom: 200px;
  }
`

const FindMyPerfectJayco = (props) => {
  const handleCtaClick = (cta) => {
    if (cta.href.indexOf('find-my-perfect-jayco/survey') !== -1) {
      dlPush({
        'event': 'jaycoEvent',
        'eventAction': 'CTA Click - Find My Perfect Jayco',
        'eventCategory': 'Research',
        'eventLabel': 'Start Now'  
      })
    }
  }

  return (
  	<Container>
      {props.heroBanner &&
        <Banner
          onCtaClick={handleCtaClick}
          {...props.heroBanner}
        />
      }
      {props.heroBannerSlider &&
        <BannerSlider
          {...props.heroBannerSlider}
          ctaPlacement='top'
        />
      }
    </Container>
  )
}

export async function getStaticProps() {
  
  const countryCode = process.env.DEV_COUNTRY_CODE ? process.env.DEV_COUNTRY_CODE : process.env.COUNTRY_CODE;
  const FIND_MY_PERFECT_JAYCO = gql`
    query FIND_MY_PERFECT_JAYCO {
      pageBy(uri: "find-my-perfect-jayco?${countryCode.toLowerCase()}") {
        title
        seo {
          ${seoQuery}
        }
        acf_domains {
          assignedDomains
        }
        ${contentBuilderQuery()}
      }
    }
  `
  const result = await client.query({
    query: FIND_MY_PERFECT_JAYCO,
  });

  const context = get(result, 'data.pageBy', {});
  const cbData = get(result, 'data.pageBy.acf_content_builder.contentBuilder', null);

  // First item could be hero banner or hero banner carousel

  // Hero banner
  const hasBanner = get(cbData, '[0].fieldGroupName', '') === 'page_AcfContentBuilder_ContentBuilder_FcSingleHeroBanner';
  const heroBanner = hasBanner ? refactorHb(cbData[0]) : null;

  // Banner carousel
  const hasCarousel = get(cbData, '[0].fieldGroupName', '') === 'page_AcfContentBuilder_ContentBuilder_FcHeroBannerCarousel';
  const heroBannerCarousel = hasCarousel ? refactorHBCData(cbData[0]) : null;

  const assignedDomains = get(result, 'data.pageBy.acf_domains.assignedDomains', []);

  
  // Pass post data to the page via props
  return {
    revalidate: (process.env.NEXT_STATIC_EXPORT && process.env.NEXT_STATIC_EXPORT.toString() === 'true') ? false : 1,
    props: { 
      meta: {
        title: context && context.title,
        seo: context && context.seo,
        assignedDomains
      },
      breadcrumbs: await refactorBreadcrumbsData('/find-my-perfect-jayco', assignedDomains),
      heroBanner,
      heroBannerCarousel,
    }
  }
}

FindMyPerfectJayco.propTypes = {
}

export default FindMyPerfectJayco